import styled from 'styled-components';

export const StyledSwitch = styled.div`
    display: flex;
    padding: 44px 0;

    @media(max-width: 768px) {
        padding: 15px 0;
    }
`